import React from "react";

// components
import PageTitle from "../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingButton from '@mui/lab/LoadingButton';
import getFornitori from "../services/getFornitori";
import { InputAdornment, MenuItem, Stack, TextField } from "@mui/material";
import SettingsTitle from "../widgets/SettingsTitle";
import ManageRowSettings from "../widgets/ManageRowSettings";
import getFornitore from "../services/getFornitore";
import _default from "../themes/default";
import getProdottiFornitore from "../services/getProdottiFornitore";
import MultiSelectSearch from "../widgets/MultiSelectSearch";
import checkToken from "../services/checkToken";
import getOrdineFornitore from "../services/getOrdineFornitore";
import editOrdineFornitoreConferma from "../services/editOrdineFornitoreConferma";
import deleteOrdineFornitoreConferma from "../services/deleteOrdineFornitoreConferma";
import editOrdineFornitore from "../services/editOrdineFornitore";
import MyModalMail from "../widgets/MyModalMail";
import inviaFornitore from "../services/inviaFornitore";
import addMerceIngresso from "../services/addMerceIngresso";
import addReminder from "../services/addReminder";
import editOrdineFornitoreConcluso from "../services/editOrdineFornitoreConcluso";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });
let current = cookies.get('ordineFornitore', { path: '/' });

const rowTitle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 4,
    borderBottom: '0.3px solid #c1c1c1',
    marginTop: 30,
    marginBottom: 20
}

const groupInput = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 5
}

export default class EditOrdineFornitore extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            id_ordine: undefined,
            id_fornitore: '',
            fornitori: [],
            prodotti: [],
            fornitore: '',
            descrizione: '',
            dataConsegna: '',
            selectedDisposizione: [],
            prodottiList: [],
            rif: '',
            inviato: 0,
            pdfConferma: '',
            linkPdfConferma: '',
            dataConfermata: 0,
            modalMail: {
                show: false,
                link: '',
            },
            concluso: false
        };

        this.disposizioni = [
            { value: 0, label: 'Immediato' },
            { value: 30, label: '30 GG.DF.FM.' },
            { value: 60, label: '60 GG.DF.FM.' },
            { value: 90, label: '90 GG.DF.FM.' },
            { value: 120, label: '120 GG.DF.FM.' },
            { value: 150, label: '150 GG.DF.FM.' },
            { value: 180, label: '180 GG.DF.FM.' }
        ];
    }

    async componentDidMount() {
        this.reload()
    }

    async reload() {
        this.setState({ loading: true })
        username = cookies.get('username', { path: '/' });
        token = cookies.get('token', { path: '/' });
        current = cookies.get('ordineFornitore', { path: '/' });

        const check = await checkToken(username, token, true);
        const userType = check.utente.tipo;

        let ordiniFornitoreLink = '';

        let ordineFornitore = await getOrdineFornitore(username, token, current);
        let res = await getFornitori(username, token);
        res.forEach((c, i) => {
            res[i].label = c.ragione_sociale
        })

        let prodottiList = await getProdottiFornitore(username, token, parseInt(ordineFornitore.id_fornitore));

        let prodotti = [];
        prodotti = [...JSON.parse(ordineFornitore.prodotti)];

        switch (userType) {
            case '0':
                ordiniFornitoreLink = '#/app/ordini-fornitori';
                break;
            case '1':
                ordiniFornitoreLink = '#/tecnico/ordini';
                break;
            case '3':
                ordiniFornitoreLink = '#/commerciale/ordini';
                break;
            case '4':
                ordiniFornitoreLink = '#/service/ordini-fornitori';
                break;
            default:
                break;
        }

        this.setState({
            id_ordine: current,
            fornitori: res,
            fornitore: parseInt(ordineFornitore.id_fornitore),
            descrizione: ordineFornitore.descrizione,
            prodotti: prodotti,
            totale: parseFloat(ordineFornitore.totale),
            dataConsegna: ordineFornitore.data_consegna,
            selectedDisposizione: ordineFornitore.disposizioni ? JSON.parse(ordineFornitore.disposizioni) : [],
            id: ordineFornitore.id,
            rif: ordineFornitore.rif,
            inviato: parseInt(ordineFornitore.inviato),
            dataConfermata: parseInt(ordineFornitore.data_confermata),
            loading: false,
            prodottiList: prodottiList,
            ordiniFornitoreLink,
            linkPdfConferma: ordineFornitore.link_conferma ? ordineFornitore.link_conferma : '',
            isUserType: parseInt(userType),
            concluso_magazzino: ordineFornitore.concluso_magazzino === '1',
            concluso: ordineFornitore.concluso === '1'
        });
    }

    async onChangePdfConferma(username, token, base64_payload, rif, id_ordine) {
        const res = await editOrdineFornitoreConferma(username, token, base64_payload, rif, id_ordine);
        if (res.result === "ok") {
            if (this.state.isUserType === 0) {
                addReminder(username, token, 'Confermato ordine fornitore: ' + rif, 'service', 'notifica ordine fornitore', id_ordine);
                addReminder(username, token, 'Confermato ordine fornitore: ' + rif, 'magazzino', 'notifica ordine fornitore magazzino', id_ordine);
            } else {
                addReminder(username, token, 'Confermato ordine fornitore: ' + rif, 'amministrazione', 'notifica ordine fornitore', id_ordine);
                addReminder(username, token, 'Confermato ordine fornitore: ' + rif, 'magazzino', 'notifica ordine fornitore magazzino', id_ordine);
            }
        } else {
            console.log(res)
        }
    }

    close() {
        let modalMail = this.state.modalMail;
        modalMail.show = false;
        this.setState({ modalMail });
    }

    async onDeletePdfConferma(username, token, id, rif) {
        const res = await deleteOrdineFornitoreConferma(username, token, id, rif);
        if (res.result === "ok") {
            this.setState({ linkPdfConferma: '' });
        } else {
            console.log(res)
        }
    }

    async loadFornitore(id) {
        this.setState(() => ({ fornitore: null, prodotti: [] }), async () => {
            this.calcolaTotale();
            let fornitore = await getFornitore(username, token, id);
            let prodotti = await getProdottiFornitore(username, token, fornitore.id);
            let prodottiFornitore = fornitore.prodotti_custom ? JSON.parse(fornitore.prodotti_custom) : [];
            prodotti.forEach((p, i) => {
                let nuovoCosto = prodottiFornitore.find(prodotto => prodotto.prodottoId === p.id);
                if (nuovoCosto)
                    prodotti[i].prezzo = nuovoCosto.price;
            });

            this.setState({
                fornitore: id,
                prodottiList: prodotti,
                selectedDisposizione: fornitore.disposizione_pagamenti ? JSON.parse(fornitore.disposizione_pagamenti) : [],
            });
        });
    }

    addInput(param) {
        let obj = { id_prodotto: null, label: '', prezzo: '', quantita: null }
        let new_array = [...this.state[param], obj]
        this.setState({ [param]: new_array })
    }

    calcolaTotale() {
        let totale = 0;
        this.state.prodotti.forEach((prodotto) => {
            totale += (parseFloat(prodotto.prezzo) * parseInt(prodotto.quantita));
        })
        this.setState({ totale: totale.toFixed(2) })
    }

    render() {
        return (
            <>
                {
                    this.state.modalMail.show && <MyModalMail modal={this.state.modalMail} userType={this.state.isUserType} dataConsegna={this.state.dataConsegna} title={"Personalizza la tua email"} onClose={this.close.bind(this)} onReload={() => this.reload()} />
                }
                <PageTitle title={`Modifica Ordine Fornitore: ${this.state.rif}`} />

                <Stack spacing={3}>
                    <Stack direction={"row"} spacing={1} sx={{ flex: 1 }} >
                        <TextField
                            inputProps={{ readOnly: this.state.inviato === 1 }}
                            fullWidth select value={this.state.fornitore} label="Fornitore" onChange={(e) => {
                                this.setState({ fornitore: e.target.value });
                            }} >
                            {this.state.fornitori.map((fornitore, i) => <MenuItem key={i} value={fornitore.id}>{fornitore.label}</MenuItem>)}
                        </TextField>
                        <TextField inputProps={{ readOnly: this.state.inviato === 1 }} fullWidth variant="outlined" label={'Riferimento'} value={this.state.rif} onChange={(e) => this.setState({ rif: e.target.value })} />
                    </Stack>
                    <TextField inputProps={{ readOnly: this.state.inviato === 1 }} fullWidth multiline rows={4} variant="outlined" label={'Descrizione'} value={this.state.descrizione} onChange={(e) => this.setState({ descrizione: e.target.value })} />
                </Stack>

                {
                    this.state.fornitore && (
                        <>
                            <Stack spacing={3} sx={{ flex: 1 }}>
                                <div style={rowTitle}>
                                    <SettingsTitle title="Prodotti" />
                                    {!(this.state.inviato === 1) && <img src={require('../images/add.png')} alt="" style={{ cursor: 'pointer', width: 20, height: 20, alignSelf: 'flex-end' }} onClick={() => this.addInput('prodotti')} />}
                                </div>
                                <div>
                                    {this.state.prodotti.map((el, i) => {
                                        return (
                                            <div key={i} style={groupInput}>
                                                <Stack direction={"row"} spacing={1} sx={{ flex: 1 }} >
                                                    <TextField
                                                        inputProps={{ readOnly: this.state.inviato === 1 }}
                                                        fullWidth
                                                        select
                                                        value={el.label}
                                                        label="Prodotto"
                                                        onChange={(e) => {
                                                            let arr = [...this.state.prodotti]
                                                            arr[i].label = e.target.value;
                                                            arr[i].prezzo = this.state.prodottiList.find((n) => n.nome === e.target.value).prezzo;
                                                            arr[i].id_prodotto = this.state.prodottiList.find((n) => n.nome === e.target.value).id;
                                                            arr[i].quantita = 1;
                                                            this.setState(() => ({ prodotti: arr }), () => this.calcolaTotale());
                                                        }}
                                                    >
                                                        {
                                                            this.state.prodottiList.map((prodotto, i) => {
                                                                return (
                                                                    <MenuItem key={i} value={prodotto.nome}>{prodotto.nome}</MenuItem>
                                                                )
                                                            })
                                                        }
                                                    </TextField>
                                                    <TextField
                                                        inputProps={{ readOnly: this.state.inviato === 1 }}
                                                        InputLabelProps={{ shrink: el.quantita }}
                                                        type="number"
                                                        variant="outlined"
                                                        label={'Quantita'} value={el.quantita}
                                                        onChange={(e) => {
                                                            let arr = this.state.prodotti
                                                            arr[i].quantita = e.target.value
                                                            this.setState(() => ({ prodotti: arr }), () => this.calcolaTotale());
                                                        }} />
                                                    <TextField
                                                        InputProps={{ endAdornment: <InputAdornment position="end">€</InputAdornment>, readOnly: this.state.inviato === 1 }}
                                                        type="number"
                                                        variant="outlined"
                                                        label={'Prezzo Unit'} value={el.prezzo}
                                                        onChange={(e) => {
                                                            let arr = this.state.prodotti
                                                            arr[i].prezzo = e.target.value
                                                            this.setState(() => ({ prodotti: arr }), () => this.calcolaTotale());
                                                        }} />
                                                    {
                                                        !(this.state.inviato === 1) &&
                                                        <ManageRowSettings
                                                            callback={() => {
                                                                let updated = this.state.prodotti.filter((e, index) => index !== i)
                                                                this.setState(() => ({ prodotti: updated }), () => {
                                                                    this.calcolaTotale();
                                                                })
                                                            }}
                                                        />
                                                    }
                                                </Stack>
                                            </div>
                                        )
                                    })

                                    }
                                </div>
                            </Stack>
                            <Stack spacing={3}>
                                <TextField InputProps={{ readOnly: true, endAdornment: <InputAdornment position="end">€</InputAdornment>, }} sx={{ mt: 3 }} variant="outlined" label="Totale" value={this.state.totale} InputLabelProps={{ shrink: this.state.totale }}
                                    onChange={(e) => { this.setState({ totale: e.target.value }) }
                                    } />
                            </Stack>
                            <div style={{ height: 30 }}></div>

                            <Stack direction={"row"} spacing={1} sx={{ flex: 1 }} >
                                <TextField
                                    sx={{ flex: 1 }}
                                    type="date"
                                    value={this.state.dataConsegna}
                                    label="Data di consegna"
                                    onChange={(e) => {
                                        this.setState({ dataConsegna: e.target.value });
                                    }}
                                    InputLabelProps={{ shrink: true }}
                                    inputProps={{ readOnly: this.state.linkPdfConferma}}
                                />
                                <Stack sx={{ flex: 1 }}>
                                    <MultiSelectSearch readOnly={this.state.inviato === 1} optionsArray={this.disposizioni} labelKey={'label'} label='Disposizioni pagamento' selectedValues={this.state.selectedDisposizione} onSelected={(e) => { this.setState({ selectedDisposizione: e }) }} />
                                </Stack>
                            </Stack>
                            <div style={{ height: 30 }}></div>

                            <Stack direction='row' spacing={4} sx={{ flex: 1, mb: 3, }}>


                                {((this.state.isUserType === 0 || this.state.isUserType === 4) && this.state.linkPdfConferma === '') && !(this.state.inviato === 0) && <Stack direction='row' spacing={4} sx={{ flex: 1, mb: 3, }}>
                                    <TextField
                                        sx={{ width: '40%' }}
                                        label="Carica Conferma"
                                        type="file"
                                        variant="outlined"
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(e) => {
                                            if (this.state.dataConfermata === 0) {
                                                if (!window.confirm('La data di consegna, il totale dell’ordine e le disposizioni di pagamento sono corrette? Correggile prima di caricare la conferma dell’ordine')) {
                                                    e.target.value = null;
                                                    return;
                                                }
                                            }
                                            let file = e.target.files[0];
                                            let reader = new FileReader();
                                            reader.readAsDataURL(file);
                                            reader.onload = () => {
                                                this.setState({ pdfConferma: reader.result });
                                                this.onChangePdfConferma(username, token, this.state.pdfConferma, this.state.rif, this.state.id);
                                            };
                                            reader.onerror = function (error) {
                                                console.log('Error: ', error);
                                            };
                                            getOrdineFornitore(username, token, this.state.id_ordine).then(ordine => {
                                                addMerceIngresso(username, token, this.state.fornitore, ordine['prodotti'], this.state.dataConsegna, this.state.id_ordine).then(res => {
                                                    window.location.href = this.state.ordiniFornitoreLink;
                                                })
                                            })
                                        }}
                                    />
                                </Stack>}

                                {(this.state.isUserType === 0 || this.state.isUserType === 4) && this.state.linkPdfConferma !== '' &&
                                    <LoadingButton variant="contained" onClick={() => { window.open(this.state.linkPdfConferma, '_blank'); }} sx={{ height: 50, width: 300, }} >Apri documento di conferma</LoadingButton>
                                }

                                {(this.state.isUserType === 0 || this.state.isUserType === 4) && this.state.linkPdfConferma !== '' &&
                                    <LoadingButton variant="contained" color="error" onClick={() => this.onDeletePdfConferma(username, token, this.state.id, this.state.rif)} sx={{ height: 50, width: 300 }} >Elimina documento di conferma</LoadingButton>
                                }

                            </Stack>

                            <Stack direction='row' spacing={4} sx={{ flex: 1, mb: 3, }}>
                                {!(this.state.inviato === 1) && <LoadingButton sx={{ minHeight: 50 }} style={{ backgroundColor: _default.palette.primary.main }} variant='contained' loading={this.state.isLoading} onClick={() => this.save()}>Salva</LoadingButton>}
                                {this.state.inviato === 0 && (this.state.isUserType === 0 || this.state.isUserType === 4) &&
                                    <LoadingButton variant="contained" onClick={() => {
                                        inviaFornitore(username, token, current).then(res => {
                                            if (res.result === 'ok') {
                                                let x = {
                                                    show: true,
                                                    link: res.link,
                                                    id_fornitore: this.state.fornitore,
                                                    id_ordine: current,
                                                    rif: this.state.rif,
                                                    fornitore: true,
                                                };
                                                this.setState({ modalMail: x });
                                            }
                                        })
                                    }}
                                        sx={{ height: 50, width: 300, }} >Invia al fornitore</LoadingButton>
                                }
                                {this.state.concluso_magazzino && !this.state.concluso && this.state.isUserType === 4 && <LoadingButton
                                    variant="contained"
                                    color="success"
                                    onClick={() => {
                                        if (window.confirm('Concludere l\'ordine?')) {
                                            editOrdineFornitoreConcluso(username, token, current).then(res => {
                                                if (res.result === 'ok') {
                                                    addReminder(username, token, 'Concluso ordine fornitore: ' + this.state.rif, 'amministrazione', 'notifica ordine fornitore', current);
                                                    window.location.href = this.state.ordiniFornitoreLink;
                                                }
                                            });
                                        }
                                    }}
                                    sx={{ height: 50, width: 300, }} >Concludi ordine</LoadingButton>
                                }
                            </Stack>
                        </>
                    )
                }
            </>
        );
    }

    async save() {

        if (!this.state.fornitore) {
            alert('Inserire un fornitore valido');
            return;
        }

        if (!this.state.descrizione) {
            alert('Inserire una descrizione valida');
            return;
        }

        if (this.state.prodotti.length === 0) {
            alert('Inserire un prodotto');
            return;
        }

        if (!this.state.totale) {
            alert('Inserire un totale valido');
            return;
        }

        if (!this.state.dataConsegna) {
            alert('Inserire una data di consegna valida');
            return;
        }

        if (this.state.selectedDisposizione.length === 0) {
            alert('Inserire una disposizione di pagamento');
            return;
        }

        this.setState({ isLoading: true });

        let ordineFornitore = {
            id: this.state.id,
            fornitore: this.state.fornitore,
            descrizione: this.state.descrizione,
            prodotti: JSON.stringify(this.state.prodotti),
            totale: this.state.totale,
            data_consegna: this.state.dataConsegna,
            disposizioni: JSON.stringify(this.state.selectedDisposizione),
            rif: this.state.rif,
        };

        let res = await editOrdineFornitore(username, token, ordineFornitore);

        if (res.result === 'KO UPDATE') {
            this.setState({ isLoading: false });
            alert(res['message']);
            return;
        }

        if (res.result === 'ok') {
            if (this.state.isUserType === 0) {
                addReminder(username, token, 'Modificato ordine fornitore: ' + this.state.rif, 'service', 'notifica ordine fornitore', this.state.id_ordine);
            } else {
                addReminder(username, token, 'Modificato ordine fornitore: ' + this.state.rif, 'amministrazione', 'notifica ordine fornitore', this.state.id_ordine);
            }
            window.location.href = this.state.ordiniFornitoreLink;
            return;
        }

        this.setState({ isLoading: false });
        alert('Si è verificato un errore durante la creazione dell\'ordine. Per favore, riprova.');
    }

}
